
import axios from "axios";

export class HttpHandlerLegacy {
    createInstance (baseUrl) {
        const instance = axios.create({
            baseURL: baseUrl,
            headers: {
                'Content-Type': 'application/json',
            }
        });
        instance.interceptors.response.use(function onFulfilled(response) {
            return response;
        }, function onRejected(error) {
            return error.response.data;
        });
        return instance;
    }
}
